/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';

@tagName('span')
class DurationWithTimestampComponent extends Component {
  // Static Properties
  @service('moment') momentService;

  // External API
  timestamp = null;

  referenceTimestamp = null;
  fallback = 'less than a second';
  tail = '';
  timestampPrefix = '';

  @computed('timestamp', 'timestampPrefix', 'momentService.currentTime')
  get detailedTimestamp() {
    let momentService = this.get('momentService');
    let timestamp = this.get('timestamp');

    return `${this.get('timestampPrefix')}${momentService.formatTimestamp([timestamp])}`;
  }
}

DurationWithTimestampComponent.reopenClass({
  positionalParams: ['referenceTimestamp', 'timestamp'],
});

export default DurationWithTimestampComponent;
